export const LOGO_PIN = "https://customer-assets-agu9un31.emergentagent.net/job_landing-page-210/artifacts/7dggnbsz_GeoDyn-removebg-preview.png";
export const LOGO_WORDMARK = "https://customer-assets-cm19k8pv.emergentagent.net/job_52bd336a-293f-4828-9534-98ae60c73350/artifacts/1xc5gj92_GeoDyn.png";

export const HERO_BG = "https://images.pexels.com/photos/33175694/pexels-photo-33175694.jpeg";
export const DATA_BG = "https://images.unsplash.com/photo-1768330187404-59e46cf222c9";
export const PARKING_BG = "https://images.unsplash.com/photo-1774894758650-477d55737f09";
export const SOLUTION_IMG = "https://images.pexels.com/photos/37894518/pexels-photo-37894518.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
export const MARKET_IMG = "https://images.unsplash.com/photo-1637970067784-927e66e07e36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
export const FOOTER_VIDEO = "https://videos.pexels.com/video-files/33846351/14363788_3840_2160_60fps.mp4";

// Live public Ocean City parking / demand camera feeds (ipcamlive). Resolved live via /api/live/lots.
export const liveLots = [
  { name: "Inlet Lot — Main View", city: "Ocean City, MD", pick: "Inlet · Main", alias: "5aec8d9905b9a", total: 1100, baseOcc: 0.63 },
  { name: "Inlet Lot — Corner View", city: "Ocean City, MD", pick: "Inlet · Corner", alias: "62adf6476c66b", total: 1100, baseOcc: 0.57 },
];

export const heroChips = [
  "Maximize Revenue",
  "Reduce Congestion",
  "Optimize Utilization",
  "Real-Time Intelligence",
];

export const problems = [
  "Static pricing leads to lost revenue",
  "Drivers waste time circling for spots",
  "Congestion, emissions, and frustration increase",
  "Cities lack real-time visibility into demand",
];

export const solutions = [
  "Real-time pricing based on demand, location & behavior",
  "Maximize revenue for operators & cities",
  "Improve utilization across every space",
  "Reduce congestion and emissions",
  "Better outcomes for residents and driving community",
];

export const steps = [
  { n: "01", t: "Integrate", d: "Set up dynamic pricing. Apply adjusted parking prices in respect to city events and daily fluctuating parking demand." },
  { n: "02", t: "Increase Revenue", d: "Increase revenue for the city budget and subsidize other city service programs." },
  { n: "03", t: "Happier Residential Community", d: "Improve driver community satisfaction and deliver a better public service experience for city residents." },
];

export const impactStats = [
  { label: "Revenue Increase", value: "+15–30%", desc: "Higher parking revenue for cities and operators.", color: "#8DC63F" },
  { label: "Reduced Congestion", value: "−10–25%", desc: "Less time circling, lower emissions, smoother flow.", color: "#00E5FF" },
  { label: "Utilization Increase", value: "+20%+", desc: "More efficient use of parking assets and spaces.", color: "#8DC63F" },
  { label: "Time to Find Parking", value: "↓ Significantly", desc: "Drivers find parking faster, improving the urban experience.", color: "#00E5FF" },
];

export const revenueData = [
  { m: "M1", v: 100 }, { m: "M2", v: 108 }, { m: "M3", v: 119 },
  { m: "M4", v: 128 }, { m: "M5", v: 141 }, { m: "M6", v: 152 },
  { m: "M7", v: 166 }, { m: "M8", v: 178 }, { m: "M9", v: 193 },
  { m: "M10", v: 208 }, { m: "M11", v: 224 }, { m: "M12", v: 242 },
];

export const businessModel = [
  { t: "SaaS Subscription", d: "A recurring platform license and subscription for cities and operators." },
  { t: "Increase Revenue", d: "Cities remove their dependency on third parties (e.g. ParkMobile, PayByPhone) and keep a bigger cut of parking revenue." },
  { t: "Data & Analytics", d: "Insights and intelligence products as a future upsell." },
];

export const marketPoints = [
  "Thousands of municipalities worldwide",
  "Millions of on-street and off-street spaces",
  "Parking is a $100B+ market ripe for innovation",
];

export const whyGeodyn = [
  "We optimize. Others just process payments.",
  "Works on top of existing infrastructure.",
  "No rip-and-replace deployment.",
  "Real-time. Predictive. Proven impact.",
];

export const traction = [
  "Early platform development complete",
  "Pilot programs in discussions with municipalities & operators",
  "Strong interest from industry advisors and partners",
];

export const visionPoints = ["More revenue.", "Less traffic.", "Better cities.", "Happier people."];

export const faqs = [
  { q: "What is GeoDyn Parking?", a: "GeoDyn is the intelligence layer for parking, a geo-dynamic pricing platform that sits on top of your existing parking systems and adjusts prices in real time based on demand, location and city events." },
  { q: "How does dynamic parking pricing work?", a: "GeoDyn analyzes real-time and historical signals like demand, location, events and daily fluctuations, and automatically applies optimal prices, the way airlines and ride-hailing already price demand." },
  { q: "Do we have to replace our current parking system?", a: "No. GeoDyn is a layer that works on top of the infrastructure you already run, with no rip-and-replace required. It can also run on its own." },
  { q: "How does GeoDyn increase city revenue?", a: "By pricing dynamically and removing dependency on third parties, cities capture a bigger cut of parking revenue, which can fund the city budget and subsidize other city service programs." },
  { q: "Who is GeoDyn built for?", a: "Cities, municipalities and parking operators that want to grow revenue, improve utilization, reduce congestion and deliver a better experience for residents." },
  { q: "How is GeoDyn different from ParkMobile or PayByPhone?", a: "Third parties focus on payment processing. GeoDyn focuses on intelligence and optimization, making every parking system smarter and more profitable." },
];
